export function formatNameListForSimplePredicates(
  names: (string | undefined)[],
  summarize: boolean,
): string {
  const filtered = names.filter((name): name is string => !!name);
  if (filtered.length === 0) return '';
  if (!summarize || filtered.length === 1) return filtered.join(', ');
  return `${filtered[0]} +${filtered.length - 1}`;
}
